import { combineReducers } from '@fullstory/redux-util/utils/combineReducers';
import { Highlights } from '@fullstory/client-api';
import { HighlightsActions } from './actions';
import { HighlightsRequestTypes, HighlightsActionTypes } from './types';
import {
  createLoadingReducer,
  createErrorReducer,
} from '@fullstory/redux-util/middleware/request/reducers';
import { isNonNull } from '@fullstory/typeutils';

const data = (
  state: Highlights = {
    Seats: [],
    Highlights: [],
    PreviousHighwater: 0,
    Cursor: '',
    HasMore: false,
    ActiveIntegrations: {},
  },
  action: HighlightsActions,
): Highlights => {
  switch (action.type) {
    case HighlightsRequestTypes.FetchHighlightsSuccess:
      return {
        ...state,
        ...action.data,
        Highlights: action.data?.Highlights?.filter(isNonNull) || [],
      };
    case HighlightsActionTypes.UpdateHighlightSentIntegration: {
      const highlights = state.Highlights?.map(highlight => {
        if (!highlight) return null;

        if (highlight.Id === action.highlightId) {
          highlight.SentIntegrations
            ? (highlight.SentIntegrations[action.integrationId] = action.url)
            : (highlight.SentIntegrations = { [action.integrationId]: action.url });
        }

        return highlight;
      });

      return {
        ...state,
        Highlights: highlights || [],
      };
    }
    case HighlightsRequestTypes.DeleteHighlightSuccess: {
      const highlightId = action.request.body?.highlightId;

      if (highlightId == null) {
        throw new Error(
          `Redux action ${HighlightsRequestTypes.DeleteHighlightSuccess} expected action.request.body.highlightId to be defined but instead got ${highlightId}.`,
        );
      }

      return {
        ...state,
        Highlights: state.Highlights?.filter(highlight => highlight?.Id !== highlightId) || [],
      };
    }
  }
  return state;
};

const loading = createLoadingReducer(
  HighlightsRequestTypes.FetchHighlightsRequest,
  HighlightsRequestTypes.FetchHighlightsSuccess,
  HighlightsRequestTypes.FetchHighlightsFailure,
);

const error = createErrorReducer(
  HighlightsRequestTypes.FetchHighlightsRequest,
  HighlightsRequestTypes.FetchHighlightsSuccess,
  HighlightsRequestTypes.FetchHighlightsFailure,
);

type HighlightsState = {
  loading: ReturnType<typeof loading>;
  error: ReturnType<typeof error>;
  data: ReturnType<typeof data>;
};

const highlights = combineReducers<HighlightsState>({
  loading,
  error,
  data,
});

type HighlightsReducerState = {
  highlights: ReturnType<typeof highlights>;
};

export const highlightsReducer = combineReducers<HighlightsReducerState>({
  highlights,
});
